export default __webpack_public_path__ + "static/media/code-tags.bafb4730.svg";